import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";

export default class MapLocationFieldWidgetUtil extends FieldWidgetUtil {

  onLocationPicked = async (selectedLocation: string, address: string) => {
    this.inputFieldValueRef.value = selectedLocation;
    let parsedValue = this.formatterInstance.parse(this.fieldMetaData.fieldSpecs, selectedLocation);
    let originalValue = this.fetchFieldValue();
    if (this.fieldMetaData.enabled)
      NamaCommon.setFieldValue(this.presenter.fetchRecord(), this.fieldId().replace(".mapLocation", ".address2"), address);
    await this.updateValueAndCallPostAction(parsedValue, originalValue);
  }
}
